import { isAuth } from '@/services/PermissionService';
import Content from '@/components/layout/Content';
import Names from './names';
import { hasPermission, MANAGER, OWNER, POS_VIEW_DISCOUNTS, SUPER_ADMIN } from '@/middlewares/permissions';

export default {
	path: '/discounts',
	component: Content,
	children: [
		{
			path: '/discounts',
			redirect: '/discounts/list',
		},
		{
			path: 'list',
			name: Names.DiscountList,
			component: () => import('../views/discounts/List'),
			meta: {
				title: 'Discount List',
				middleware: [isAuth, (nav) => hasPermission(nav, [POS_VIEW_DISCOUNTS], [SUPER_ADMIN, OWNER, MANAGER])],
			},
		},
		{
			path: ':id',
			name: Names.DiscountDetails,
			component: () => import('../views/discounts/Details'),
			meta: {
				title: 'Discount Details',
				middleware: [isAuth, (nav) => hasPermission(nav, [POS_VIEW_DISCOUNTS], [SUPER_ADMIN, OWNER, MANAGER])],
			},
		},
	],
};
